export default "__VITE_ASSET__88ba0c8b__"